module.exports = __webpack_public_path__ + "static/img/MORARA.0629691e.png";